import { ThemeData } from "../../api/personalization/theme/data";
import DropdownControl from "../../components/DropdownControl";

type ThemeDropdownProps = {
  themes: ThemeData[] | null;
  selected: number;
  onSelected: (theme: number) => void;
};

const ThemeDropdown: React.FC<ThemeDropdownProps> = ({
  selected,
  themes,
  onSelected,
}) => {
  if (!Array.isArray(themes) || themes.length === 0) return null;

  const _onSelected = (id: string | null) => {
    const index = themes.findIndex((item) => item.Code === id);
    if (index !== -1) {
      onSelected(index);
    }
  };

  return (
    <DropdownControl
      text="Default Theme"
      selected={selected}
      items={themes.map((item) => item.Code)}
      onSelected={_onSelected}
    />
  );
};

export default ThemeDropdown;
